import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=63f5717a&"
import script from "./ListHeader.vue?vue&type=script&lang=ts&"
export * from "./ListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ListHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports